import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  CRITICAL_ERRORS,
  ImportOrderValidationErrorTypeEnum,
} from '@order/pages/import-order-validation/constants/import-order-validation.constants';
import { PlatformService } from '@panamax/app-state';
import { getContractPillType } from '@product-detail/utils/product-tags-util';
import { ChipTypeEnum } from '@shared/components/usf-chip/models/chip-type.enum';
import { TagProduct } from '@shared/components/usf-product-tag-list/models/tag-product.model';
import { ApiUpdatable } from '@shared/models/api-updatable';
import { QuantityUpdate } from '@shared/models/quantity-update';
import { OrderItem } from '@usf/order-types';

@Component({
  selector: 'app-import-order-validation-split-product',
  templateUrl: './import-order-validation-split-product.component.html',
  styleUrls: ['./import-order-validation-split-product.component.scss'],
})
export class ImportOrderValidationSplitProductComponent implements OnChanges {
  @Input() orderItem: OrderItem;
  @Input() orderHeaderErrorMsg: string;
  @Input() orderHeaderErrorCode: string;
  @Input() vendorDirectTag: TagProduct;
  @Input() contractTag: TagProduct;
  @Input() unitsOrdered: ApiUpdatable<number>;
  @Input() eachesOrdered: ApiUpdatable<number>;
  @Input() disabledQuantities: boolean;
  @Output() removeEmitter = new EventEmitter<any>();
  @Output() quantityEmitter = new EventEmitter<QuantityUpdate>();
  @Output() replaceEmitter = new EventEmitter<any>();

  public substituteContractTag: TagProduct;
  public ErrorTypeEnum = ImportOrderValidationErrorTypeEnum;
  public hasCriticalError: boolean;

  constructor(readonly platformService: PlatformService) {}

  ngOnChanges(): void {
    this.setSubstituteContractTag();
    this.hasCriticalError =
      CRITICAL_ERRORS.includes(this.orderItem?.orderItemErrorCode) ||
      CRITICAL_ERRORS.includes(this.orderHeaderErrorCode);
  }

  setSubstituteContractTag(): void {
    const contract = this.orderItem?.subOrReplacementProduct?.contract;
    if (!this.contractTag && !!contract) {
      const pillType = getContractPillType(
        contract.iconDescription,
        contract.clientConcept,
      );
      if (!!pillType) {
        this.substituteContractTag = {
          content: `${contract.iconDescription} - Contract`,
          type: ChipTypeEnum.image,
          clickable: false,
          iconConfig: {
            name: contract.iconDescription,
            iconWidth: pillType.size,
          },
          iconUrl: pillType.iconUrl,
        };
      }
    }
  }

  remove(): void {
    this.removeEmitter.emit();
  }
}
